import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconVerticalAlignTopComponent } from "./med-icon-vertical-align-top.component";

@NgModule({
  declarations: [
    MedIconVerticalAlignTopComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconVerticalAlignTopComponent,
  ],
})
export class MedIconVerticalAlignTopModule { }
